/* eslint-disable max-len */
import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import { history } from '../routers/AppRouter';
import Table from '../components/table/table';
import TableRegisterButton from '../components/table/registerButton';
import ROUTES from '../data/routes';
import { getListDiscountCoupon, updateDiscountCoupon, deleteDiscountCoupon } from '../app/store/actions/discountCoupon';
import ModalComponent from '../components/modal';

class DiscountCouponPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      orderBy: 'DESC',
      field: 'createdAt',
      listDiscountCoupon: [],
      totalRecord: 0,
      showModal: false,
      showCancel: false,
      titleModal: '',
      titleModalBody: '',
      selectedLine: {},
    };

    this.tableHeader = [
      { key: 'couponCode', value: I18n.t('couponCode') },
      { key: 'description', value: I18n.t('couponDescription') },
      { key: 'initialDate', value: I18n.t('startDate') },
      { key: 'finalDate', value: I18n.t('endDate') },
      { key: 'amountUsed', value: I18n.t('timesUsed') },
      { key: 'status', value: I18n.t('status') },
      { key: 'action', value: I18n.t('action') },
    ];
  }

  deleteDiscountCoupon = async () => {
    this.setState({ showModal: false });
    try {
      await this.props.deleteDiscountCoupon(this.state.selectedLine.id);
      await this.getListDiscountCoupon();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error
      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError
        })
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('errorOcurred')
        })
      }
    }
  }

  updateDiscountCoupon = async (parameters = {}) => {
    try {
      await this.props.updateDiscountCoupon({ ...parameters })

      await this.getListDiscountCoupon();
    } catch (err) {

      const error = err.response && err.response.data && err.response.data.error
      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError
        })
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('errorOcurred')
        })
      }
    }
  }

  adjustData = async (count = 0, rows = []) => {
    const listDiscountCoupon = rows.map((element, index) => ({
      key: index,
      couponCode: element.couponCode,
      description: element.description,
      initialDate: moment(element.initialDate).format('L LT'),
      finalDate: moment(element.finalDate).format('L LT'),
      amountUsed: element.amountUsed,
      status: (
        <div className="row margin-left-0">
          <button
            type="button"
            className={`btn btn-${element.status ? 'warning' : 'dark'} promotion-btn-${element.status ? 'warning' : 'active'}`}
            onClick={() => this.updateDiscountCoupon({ couponId: element.id, status: !element.status })}
          >
            {(element.status)
              ? I18n.t('disable')
              : I18n.t('active')
            }
          </button>
        </div>
      ),
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {I18n.t('action')}
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => {
                  (element.status) ?
                    history.push({
                      pathname: ROUTES.FORM,
                      screenComming: 'discountCoupon',
                      selectedDiscountCoupon: element,
                    })
                    : this.setState({
                      showModal: true,
                      showCancel: false,
                      titleModal: I18n.t('couponDisabled'),
                      titleModalBody: I18n.t('noticeToEditCoupon')
                    })
                }
                }
              >
                {I18n.t('edit')}
              </button>
              {!element.couponAlreadyUsed && (
                <button
                  type="button"
                  className="dropdown-item dropdown-table"
                  onClick={() => {
                    this.setState({
                      selectedLine: { ...element },
                      showModal: true,
                      showCancel: true,
                      titleModal: I18n.t('deleteCoupon'),
                      titleModalBody: I18n.t('canNotBeUndone')
                    })
                  }}
                >
                  {I18n.t('delete')}
                </button>
              )}
            </div>
          </div>
        </div>
      ),
    }));

    this.setState({
      totalRecord: count,
      listDiscountCoupon,
    });
  }

  getListDiscountCoupon = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    try {
      const { count = 0, rows = [] } = await this.props.getListDiscountCoupon(
        limit, skip, search, orderBy, field,
      );

      await this.adjustData(count, rows);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error
      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError
        })
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch')
        })
      }
    }
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.getListDiscountCoupon();
  }

  searchTable = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.getListDiscountCoupon();
  }

  componentDidMount() {
    this.getListDiscountCoupon();
  }

  tableButtons = () => (
    <React.Fragment>
      <TableRegisterButton route={{ pathname: ROUTES.FORM, screenComming: 'discountCoupon' }} />

      <button
        onClick={() => history.push(ROUTES.UPLOAD_DISCOUNT_COUPON)}
        type="button"
        className="btn btn-secondary margin-left-10"
      >
        {I18n.t('import')}
      </button>

      <button
        onClick={() => history.push(ROUTES.DISCOUNT_COUPON_HISTORY)}
        type="button"
        className="btn btn-primary margin-left-10"
      >
        {I18n.t('historic')}
      </button>

    </React.Fragment>
  )

  render() {
    const { limit, page, listDiscountCoupon, totalRecord, titleModal, titleModalBody, showModal, showCancel } = this.state;

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={titleModal}
          showCancel={showCancel}
          body={titleModalBody}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('ok')}
          size={{ width: '350px', height: '200px' }}
          showButtons
          confirmModal={() => { showCancel ? this.deleteDiscountCoupon() : this.setState({ showModal: false }) }}
        />
        <Table
          title={I18n.t('discountCoupon')}
          buttons={this.tableButtons()}
          header={this.tableHeader}
          lines={listDiscountCoupon}
          page={page}
          perPage={limit}
          count={totalRecord || 0}
          searchItems={this.searchTable}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getListDiscountCoupon: (limit, skip, search, orderBy, field) => dispatch(getListDiscountCoupon(limit, skip, search, orderBy, field)),
  updateDiscountCoupon: (discountCouponParameter) => dispatch(updateDiscountCoupon(discountCouponParameter)),
  deleteDiscountCoupon: (couponId) => dispatch(deleteDiscountCoupon(couponId)),
});

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(DiscountCouponPage);
